class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();

    document.addEventListener('click', (event) => {
      if (event.target === this.querySelector('.upsell-back-button')) {
        this.closeUpsellDrawer();
      }
    })
  }

  setHeaderCartIconAccessibility() {
    const cartLinks = document.querySelectorAll('.header-cart-icon');

    cartLinks.forEach((cartLink) => {
      cartLink.setAttribute('role', 'button');
      cartLink.setAttribute('aria-haspopup', 'dialog');
      cartLink.addEventListener('click', (event) => {
        event.preventDefault();
        this.open(cartLink);
      });
      cartLink.addEventListener('keydown', (event) => {
        if (event.code.toUpperCase() === 'SPACE') {
          event.preventDefault();
          this.open(cartLink);
        }
      });
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {
      this.classList.add('animate', 'active');
    });

    this.addEventListener(
      'transitionend',
      () => {
        const containerToTrapFocusOn = this.classList.contains('is-empty')
          ? this.querySelector('.drawer__inner-empty')
          : document.getElementById('CartDrawer');
        const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
        trapFocus(containerToTrapFocusOn, focusElement);
      },
      { once: true }
    );

    document.body.classList.add('overflow-hidden');
    this.classList.remove('upsell-active');

    // call estimated delivery function to re-check delivery msg
    estimatedDeliveryDate();
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
    this.classList.remove('upsell-active');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if (cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') &&
      this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      console.log(`Rendering section:`, section);
      const sectionElements = section.selector
        ? document.querySelectorAll(section.selector)
        : document.querySelectorAll('#' + section.id);

        if (sectionElements.length > 0) {
          sectionElements.forEach((sectionElement) => {
            sectionElement.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
          });
        } else {
          console.error(`Element not found for section with selector: ${section.selector} or ID: ${section.id}`);
        }
    });

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.querySelector('.upsell-back-button').addEventListener('click', this.closeUpsellDrawer.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer',
      },
      {
        id: 'cart-icon-bubble',
        selector: '.header-cart-icon'
      },
      {
        id: 'left-cart-popup',
        selector: '.left-cart-popup__items-wrapper'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  openUpsellDrawer({ parentLineItemId = null, parentLineItemKey = null, noParent = false }) {
    const upsellDrawer = this.querySelector('.upsell-drawer');

    if (parentLineItemId) {
      upsellDrawer.setAttribute('data-parent-line-item-id', parentLineItemId);
      upsellDrawer.setAttribute('data-parent-line-item-key', parentLineItemKey);
    } else if (noParent) {
      upsellDrawer.removeAttribute('data-parent-line-item-id');
      upsellDrawer.removeAttribute('data-parent-line-item-key');
    }

    this.open();
    this.classList.add('upsell-active');
  }

  closeUpsellDrawer() {
    this.classList.remove('upsell-active');
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {

  connectedCallback() {
    this.parentWithAddon = this.querySelectorAll('.addon-parent-item-checkbox:has(.is_checked)');
    if(this.parentWithAddon && this.parentWithAddon.length > 0) this.manageParentWithAddon();
    // check for US market addons
    if(typeof showUSAddons === 'function') showUSAddons();
  }

  manageParentWithAddon() {
    this.parentWithAddon.forEach(item => {
      item.addEventListener('click', () => {
        this.updateQuantity(item.dataset.childLineItem, 0);
      })
    })
  }

  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '#CartDrawer .drawer__inner',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.header-cart-icon',
      },
      {
        id: 'left-cart-popup',
        section: 'left-cart-popup',
        selector: '.left-cart-popup__items-wrapper',
      },
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);